module.exports = __webpack_public_path__ + "img/shape_roulette_anime.21a80bfd.gif";